export default {"src":"/_next/static/media/milk.53182b20.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};